import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';


const PortfolioContainer = styled.div<{ backgroundImage: string }>`
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 125px;
  width: 125px;
  margin-top: 30px;
  margin-bottom: 10px;
  margin-left: 150px;
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraSmall}){
    height: 150px;
    width: 150px;
    margin-bottom: -10px;
    margin-left: 210px;
  }
  
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.small}){
    margin-left: 0;
    margin-bottom: 15px;
  }
`;

const Portfolio = () => {
  const data = useStaticQuery(graphql`
    query {
      svg: file(name: { eq: "portfolio" }) {
        publicURL
      }
    }
  `);

  return <PortfolioContainer backgroundImage={data.svg.publicURL} />;
};


export default Portfolio;
